import React, { Component } from "react";
import { IntlProvider } from "react-intl";
import en_messages from "./locales/en-US";
// import fr_messages from "./locales/fr-FR";
// import zh_MO_messages from "./locales/zh-MO";
// import zh_CN_messages from "./locales/zh-CN";
// import ro_messages from "./locales/ro-RO";
// import pl_messages from "./locales/pl-PL";
// import es_messages from "./locales/es-ES";
// import it_messages from "./locales/it-IT";
// import de_messages from "./locales/de-DE";
// import el_messages from "./locales/el-GR";
// import pt_messages from "./locales/pt-PT";
// import tr_messages from "./locales/tr-TR";
// import ja_messages from "./locales/ja-JP";

import { getDownloadUrlForAFile } from "../util/blobStorageService";

export const messages = {
  // "de-DE": de_messages,
  // "el-GR": el_messages,
  "en-US": en_messages,
  // "es-ES": es_messages,
  // "fr-FR": fr_messages,
  // "it-IT": it_messages,
  // "pl-PL": pl_messages,
  // "pt-PT": pt_messages,
  // "ro-RO": ro_messages,
  // "tr-TR": tr_messages,
  // "zh-MO": zh_MO_messages,
  // "zh-CN": zh_CN_messages,
  // "ja-JP": ja_messages,
};

const lang = navigator.language || navigator.userLanguage;
export let defualtLocale =
  localStorage.getItem("locale") || lang.substring(0, lang.indexOf("-"));
defualtLocale = messages[defualtLocale] ? defualtLocale : "en-US";

class IntlProviderWrapper extends Component {
  state = { locale: defualtLocale,
     messages: en_messages, // Initial default locale messages
    loading: true
   };

   
  async componentDidMount() {
    await this.loadCloudMessages(this.state.locale);
  }

  loadCloudMessages = async (locale) => {
    const activeLocale = locale || "en-US";
    // Determine active application based on environment title
    const activeApp = (process.env.REACT_APP_SITE_TITLE || "Insight").toLowerCase().includes("datahub") ? "Datahub" : "Insight";
    const fileName = `${activeLocale}.json`;
    const folderPath = `LocalTranslation/${activeApp}`;
    
    let loadedMessages = null;

    try {
      // 1. Attempt to download the requested locale file from the cloud
      const downloadUrl = await getDownloadUrlForAFile("digitalsolutions-storage", folderPath, fileName);
      const response = await fetch(downloadUrl);
      if (response.ok) {
        loadedMessages = await response.json();
        console.log(`Successfully loaded cloud translations for ${activeLocale}`);
      }
    } catch (e) {
      console.warn(`Failed to download cloud translations for ${activeLocale}, trying fallback:`, e);
    }

    // 2. If requested language fails, fallback to English (en-US) on the cloud
    if (!loadedMessages && activeLocale !== 'en-US') {
      try {
        console.log(`Attempting cloud en-US.json fallback for ${activeLocale}...`);
        const downloadUrl = await getDownloadUrlForAFile("digitalsolutions-storage", folderPath, "en-US.json");
        const response = await fetch(downloadUrl);
        if (response.ok) {
          loadedMessages = await response.json();
          console.log(`Successfully loaded cloud en-US translations fallback for ${activeLocale}`);
        }
      } catch (e) {
        console.warn("Failed to download cloud en-US fallback:", e);
      }
    }

    // 3. If cloud English fallback fails or storage is empty, use the local English template file
    if (!loadedMessages) {
      console.log(`Falling back to local template file for ${activeLocale}`);
      loadedMessages = en_messages;//activeApp === "Insight" ? insightEnglishJson : enUSJson;
    }

    this.setState({
      locale: activeLocale,
      messages: loadedMessages,
      loading: false
    });
  };

  changeLocale = async (locale) => {
    localStorage.setItem("locale", locale);
    this.setState({ locale });
     await this.loadCloudMessages(locale);
  };

  render() {
    const { locale,messages } = this.state;
    return (
      <IntlProvider locale={locale} messages={messages}>
        {this.props.children({ setLocale: this.changeLocale, locale })}
      </IntlProvider>
    );
  }
}

export default IntlProviderWrapper;
